<template>
  <div>
    <div class="row no-wrap">
      <div :class="['cursor-pointer', 'text-grey-8' ]" :style="(shiftTop ? 'margin-top: -4px;' : 'margin-top: 3px;')">
        с:&nbsp;
      </div>
      <div class="row">
        <div :style="(shiftTop ? 'margin-top: -2px;' : 'margin-top: 2px;')">
          <VueDatePicker utc="preserve" timezone="Europe/Moscow" :locale="$i18n.locale" :style="'width: '+fieldWidth+'px; min-width: '+fieldWidth+'px; max-width: '+fieldWidth+'px; padding-left: 6px;'" :teleport="true"
          :model-value="theModel.StartDate" @update:model-value="onStartDateChange" :enable-time-picker="showTime" v-show="!startCheckModel"
          :clearable="false" :disabled="startCheckModel" :required="true" :format="showTime ? formatTime : formatDate" :text-input="textInputOptions" />
        </div>
        <mosta-checkbox class="q-my-none q-py-none text-grey-8 my-check"
          @update:model-value="updateStartCheck" :style="shiftTop ? 'margin-left: 6px; margin-top: -6px;' : 'margin-left: 6px;'"
          :model-value="startCheckModel" :label="$t('first_receipt_date')" />
      </div>
    </div>
    <!-- <div :class="['cursor-pointer', 'text-grey-8' ]" :style="(shiftTop ? 'margin-top: -4px;' : 'margin-top: 3px;')">
      &nbsp;-&nbsp;
    </div> -->
    <div class="row no-wrap">
      <div :class="['cursor-pointer', 'text-grey-8' ]" :style="(shiftTop ? 'margin-top: -4px;' : 'margin-top: 3px;')">
        по:&nbsp;
      </div>
      <div class="row">
        <div :style="(shiftTop ? 'margin-top: -2px;' : 'margin-top: 2px;')">
          <VueDatePicker utc="preserve" timezone="Europe/Moscow" :locale="$i18n.locale" :style="'width: '+fieldWidth+'px; min-width: '+fieldWidth+'px; max-width: '+fieldWidth+'px; padding-left: 6px;'" 
          :model-value="theModel.EndDate" @update:model-value="onEndDateChange" :teleport="true" 
          :clearable="false" :disabled="endCheckModel" v-show="!endCheckModel"
          :format="showTime ? formatTime : formatDate" :text-input="textInputOptions" :enable-time-picker="showTime" />
        </div>
        <mosta-checkbox class="q-my-none q-py-none text-grey-8 my-check"
          @update:model-value="updateEndCheck" :style="shiftTop ? 'margin-left: 6px; margin-top: -6px;' : 'margin-left: 6px;'"
          :model-value="endCheckModel" :label="$t('qty_become_date')" />
      </div>
    </div>
  </div>
</template>
  
<script lang="ts">
  import { Component, Emit, Prop, Vue, Watch } from 'vue-facing-decorator';
  import DateTimeSelector from '@/components/common/datetime-selector/DateTimeSelector.vue';
  import { ColumnDateRangeDto } from '../../../../models/interfaces/entity-settings/columns/columns';
  import MostaCheckbox from '@/components/common/basic/MostaCheckbox.vue';

  @Component({
    name: 'DateRangeColumnDisplayItem',
    components: { DateTimeSelector, MostaCheckbox }
  })
  export default class DateRangeColumnDisplayItem extends Vue {
    @Prop({ default: {} as ColumnDateRangeDto })
    modelValue: ColumnDateRangeDto | undefined | null
    @Emit("update:modelValue") emitModelValue(arg: ColumnDateRangeDto | undefined | null) { return arg; }

    @Prop({ default: false })
    shiftTop!: boolean
    @Prop({ default: false })
    showTime!: boolean

    get textInputOptions() {
      return {
        enterSubmit: true,
        tabSubmit: true,
        openMenu: 'toggle',
        rangeSeparator: '-',
        selectOnFocus: false,
        format: this.showTime ? 'dd.MM.yyyy HH:mm' : 'dd.MM.yyyy'
      }
    }

    formatDate (date: Date): string {
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();

      return `${String(day).padStart(2, '0')}.${String(month).padStart(2, '0')}.${year}`;
    }

    formatTime (date: Date): string {
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      const hour = date.getHours();
      const minute = date.getMinutes();

      return `${String(day).padStart(2, '0')}.${String(month).padStart(2, '0')}.${year} ${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
    }

    get fieldWidth() {
      return this.showTime ? 140 : 100;
    }

    get theModel(): ColumnDateRangeDto | undefined | null {
      return this.modelValue
    }

    set theModel(val: ColumnDateRangeDto | undefined | null) {
      this.emitModelValue(val)
    }

    get startCheckModel(): boolean {
      return this.modelValue?.StartDate ? false : true
    }

    get endCheckModel(): boolean {
      return this.modelValue?.EndDate ? false : true
    }

    onStartDateChange(val: Date) {
      if (!this.theModel) { return }
      this.theModel = {
        ...this.modelValue as any,
        StartDate: val
      }
    }

    onEndDateChange(val: Date) {
      if (!this.theModel) { return }
      this.theModel = {
        ...this.modelValue as any,
        EndDate: val
      }
    }

    updateStartCheck(val: any) {
      if (!this.theModel) { return }
      if (val) {
        this.theModel = {
          ...this.modelValue as any,
          StartDate: undefined
        }
      } else {
        this.theModel = {
          ...this.modelValue as any,
          StartDate: new Date()
        }
      }
    }

    updateEndCheck(val: any) {
      if (!this.theModel) { return }
      if (val) {
        this.theModel = {
          ...this.modelValue as any,
          EndDate: undefined
        }
      } else {
        this.theModel = {
          ...this.modelValue as any,
          EndDate: new Date()
        }
      }
    }
  }
</script>
  
<style lang="scss">
</style>